import { motion } from 'framer-motion';
import { Loader2, Send } from 'lucide-react';

export function SubmittingSection() {
  return (
    <motion.div
      key="submitting-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center justify-center min-h-[70vh]"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.1 }}
        className="text-center"
      >
        {/* Loading spinner */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center shadow-lg shadow-blue-500/25">
          <Loader2 className="w-10 h-10 text-white animate-spin" />
        </div>

        {/* Message */}
        <h2 className="text-2xl font-semibold text-slate-900 mb-2">
          Ihr Anspruch wird eingereicht...
        </h2>
        <p className="text-slate-500">
          Dies dauert nur einen Moment
        </p>
      </motion.div>

      {/* Progress steps */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="mt-12 space-y-3"
      >
        {['Anspruchsdatensatz wird erstellt', 'Flugdetails werden gespeichert', 'Dokumente werden hochgeladen', 'Wird abgeschlossen...'].map((step, i) => (
          <motion.div
            key={step}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 + i * 0.15 }}
            className="flex items-center gap-3 text-sm text-slate-500"
          >
            <motion.div
              className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center"
              animate={{
                backgroundColor: ['#f1f5f9', '#3b82f6', '#f1f5f9'],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: i * 0.3,
              }}
            >
              <Send className="w-2.5 h-2.5 text-white" />
            </motion.div>
            {step}
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
}
